import React from 'react'


import close_icon from '../../../assets/images/icons/close-icon.png'
import CancelButton from '../../../components/loadingButton/modelCancelButton';
import {useSelector} from 'react-redux'




const PayLater = (props)=>{

    const apiResponse = useSelector(state=>{
        const {
            generatedBillId,
        } = state
        const {billId} = generatedBillId
        return{
            billId,
        }
    })
    return(
        <div>
            <div className="model-body">
                <div className="d-flex model-title">
                    <span>Pay Later</span>
                    <div 
                        className="d-flex close-ctn"
                        onClick={props.hide}>
                        <span>close</span>
                        <img src={close_icon}/>
                    </div>
                </div>
                <br/>

                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column'
                }}>
                    <span className="general-span-text-none-auto" style={{textAlign: 'center'}}>Thank You,<br/>
                        You can pay later your application fee within 30 days.</span> 
                        <br/>
                    <div className="d-flex" style={{
                            alignItems: 'center', 
                            justifyContent: 'center',
                            flexDirection: 'column'
                            }}>
                        <span className="general-span-text-none-auto" >Your generated application bill ID is:<br/></span>
                        <span className="dashboard-green-text-header">{apiResponse.billId?.id}</span>
                    </div>

                </div>

                    <div className="mt-4" style={{
                        padding: 20
                    }}>
                        <span className="general-span-text-none-auto">If you may need to pay or transfer via the bank here are bank details:</span> <br/><br/>
                        <span className="general-span-text-none-auto" style={{fontSize: '18px'}}>Bank: <span style={{color: '#0f3589'}}> GT Bank</span></span><br/>
                        <span className="general-span-text-none-auto" style={{fontSize: '18px'}}>Account Number: <span style={{color: '#0f3589'}}> 211131222151180/RWF</span></span><br/>
                        <span className="general-span-text-none-auto" style={{fontSize: '18px'}}>Account name:<span style={{color: '#0f3589'}}> Institute of Engineers Rwanda</span></span><br/>
                        <span className="general-span-text-none-auto" style={{fontSize: '18px'}}>Transaction description:<span style={{color: '#0f3589'}}> Paying application fee for Bill ID: {apiResponse.billId?.id} </span></span>
                    </div>
                
                <div 
                    style={{
                        width: '100%', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent:"center",
                        margin: '30px 0px'
                        }}>
                    <CancelButton 
                        title="OK"
                        submit={props.hide}
                        />
                </div>  
          </div> 
        </div>
    )
}

export default PayLater